import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import DialogFactory from '@/views/components/picker/dialogFactory';
import IPSDialog from '@/views/components/picker/dialog';
import { Functions } from '@/library/utils/functions';

interface CustomerTagInfo {
  tagKey?: number | string;
  actId?: number;
  tagType?: number;
  tagDesc?: string;
  tagName?: string;
}

interface CustomerTagValInfo {
  valId?: number | string;
  tagVal?: string;
  valDesc?: string;
}
interface CustomerTagList extends CustomerTagInfo {
  valList?: Array<CustomerTagValInfo>;
}

interface CustomerTagListItem extends CustomerTagInfo, CustomerTagValInfo {
  isActived?: boolean;
}

@DialogFactory
@Component({
  mixins: [style],
})
export default class CustomerScreen extends IPSDialog {
  /**
   * 参数
   */
  // 网点Id
  siteId = 0;

  // 活动Id
  actId = 0;

  sendToId = '';

  /**
   * 页面变量
   */
  footer = false;

  title = '编辑标签';

  // 最大试算人数
  maxNumber = 0;

  // 试算人数
  trialNum = 0;

  tableName = '';

  // 标签列表
  tagList: Array<CustomerTagListItem> = [];

  // 试算状态
  trialLoading = false;

  // 选中标签变化
  checkedTagChanged = false;

  // 链接状态
  isSocketReady = false;

  // 确认状态
  confirmloading = false;

  // 标签列表 二维
  tagAllList = [];

  mounted() {
    this.resetSocket(this.sendToId);
    IPSService.customerLabel({
      postParams: {
        siteId: this.siteId,
      },
    }).then((response) => {
      this.tagAllList = response.list;
      this.tagList = (response.list as CustomerTagList[])
        .flatMap((v) => {
          const { tagKey, actId, tagType, tagDesc, tagName } = v;
          return (v.valList || []).map((vl) => {
            return Object.assign({ isActived: false }, { tagKey, actId, tagType, tagDesc, tagName }, vl);
          });
        });
    });
  }

  onItemClick(d) {
    if (this.trialLoading) {
      return;
    }
    this.checkedTagChanged = !d.isActived;
    this.tagList = this.tagList.map((v, index) => {
      v.isActived = false;
      return v;
    });
    d.isActived = true;
  }

  onConfirm() {
    const actived = this.tagList.find(v => v.isActived);
    if (this.checkedTagChanged || !actived) {
      this.$message.warning('请重新试算');
    } else {
      this.confirmloading = true;
      IPSService.customerCstIdImport({
        postParams: {
          sendToId: this.sendToId,
          actId: this.actId,
          tagVal: actived.tagVal,
          valId: actived.valId,
          tagKey: actived.tagKey,
        },
      }).then((response) => {});
    }
  }

  onReset() {
    this.trialNum = 0;
    this.tagList.forEach((v) => {
      v.isActived = false;
    });
  }

  onCancel() {
    this.closeSockets();
    this.$emit('hidden');
  }

  beforeClose() {
    this.onCancel();
  }

  getChildTag(tagKey: number | string) {
    return this.tagList.filter(v => v.tagKey == tagKey);
  }

  /**
   * 试算
   * @param {null}
   * @return null
   */
  onTrial() {
    const actived = this.tagList.find(v => v.isActived);
    if (this.trialLoading || !actived) {
      return;
    }
    this.trialLoading = true;
    IPSService.actExtractionTrial({
      postParams: {
        siteId: this.siteId,
        tagKey: actived.tagKey,
        valIds: [actived.valId],
      },
    }).then(
      (response) => {
        this.trialLoading = false;
        this.trialNum = response.trialNum;
        this.tableName = response.tableName;
        this.checkedTagChanged = false;
      },
      () => {
        this.trialLoading = false;
      },
    );
  }

  // 创建连接
  createSocket(sendToId?) {
    setTimeout(() => {
      console.log('socket建立连接');
      this.$socket.connect(); // socket建立连接
      this.onSokectConnect(sendToId); // 打开socket
    }, 0);
    // 由于socket重新连接需要时间，所以延迟
    setTimeout(() => {
      this.isSocketReady = true;
    }, 1500);
  }

  /**
   * 连接socket 生成消息体
   * @return null
   */
  onSokectConnect(sendToId): void {
    this.$socket.emit('login', sendToId); // 发送信息给服务端
    this.sockets.subscribe('new_msg', (msg) => {
      // 接收服务端的信息
      if (msg) {
        const msgArr = msg.split('|');
        console.log('msg==================', msg, msgArr[0] === 'success');
        if (msgArr[0] === 'success') {
          // 导入成功 第二位为成功条数
          if (msgArr[msgArr.length - 2] == 0) {
            this.tableName = msgArr[msgArr.length - 1];
            this.confirmloading = false;
            this.closeSockets();
            this.$emit('result', { tagList: this.tagList.filter(v => v.isActived), tableName: this.tableName });
            this.$emit('hidden');
          }
        } else {
          this.confirmloading = false;
          this.$message.warning('请重试');
        }
      }
    });
  }

  closeSockets() {
    this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket.disconnect(); // 断开连接
  }

  // 重启socket
  resetSocket(sendToId) {
    this.isSocketReady = false;
    this.closeSockets();
    this.createSocket(sendToId);
  }

  renderFooter(h) {
    return (
      <div class="dialog-footer">
        <div>
          <span class={['trial', (this.trialLoading || !this.tagList.find(v => v.isActived)) && 'disabled']} onClick={this.onTrial.bind(this)}>
            {this.trialLoading ? '试算中...' : '试算'}
          </span>
          <span class="trial-result">试算人数:&nbsp;&nbsp;{this.trialNum}</span>
        </div>
        <div>
          <el-button onClick={this.onCancel.bind(this)}>取消</el-button>
          <el-button onClick={this.onReset.bind(this)}>重置</el-button>
          <el-button type="primary" onClick={this.onConfirm.bind(this)} disabled={!this.trialNum || this.trialNum > this.maxNumber || !this.isSocketReady || this.confirmloading}>
            确认
          </el-button>
        </div>
      </div>
    );
  }

  renderContent(h) {
    return (
      <div class="task-tag-dialog">
        <div class="tag-container">
          <div class="tip">
            <span class="redText">*&nbsp;</span>在试算完成后点击确定按钮,试算人数不能大于{this.maxNumber}
          </div>
          {this.tagAllList.map((ta) => {
            return [
              <div class="tag-key">{ta.tagName}</div>,
              <div class="tag-val">
                {this.getChildTag(ta.tagKey).map((d, i) => {
                  return (
                    <span class={['tag-item multiple', d.isActived ? 'checked' : 'uncheck', this.trialLoading && 'disabled']} on-click={() => this.onItemClick(d)}>
                      <div class="item-name">{d.tagVal}</div>
                    </span>
                  );
                })}
              </div>,
            ];
          })}
        </div>
        {this.renderFooter(h)}
      </div>
    );
  }
}
